import {
  APPLY_SETTING_TYPE,
  ACTION_NAME,
  LICENSES,
  CONTENT_TYPE,
  ERROR_MESSAGE,
  USER_ROLE_MANGEMENT_MSG,
  STATUS,
} from 'constants/Constant'
import { LOGIN_HISTORY_ROUTE, EXPORT_LOGIN_HISTORY_ROUTE } from 'constants/constantDeviceUsers'
import { getFunctions, httpsCallable } from 'firebase/functions'
import moment from 'moment'
import axiosCF from 'utils/axios'
import axiosZS from 'utils/axiosZS'
import { axiosMDNA, axiosEnrollment, axiosMDNAv2 } from 'utils/axiosDUv2'
import { getRegionalFunctions } from 'auth/FirebaseAuth'
import { createHeader } from 'utils/header-zs'

// connectFunctionsEmulator(getRegionalFunctions(), '127.0.0.1', '5001')

function getUserList(tenantId) {
  return new Promise(function (resolve, _reject) {
    let getFireBaseUserList = httpsCallable(getRegionalFunctions(), 'getUserList')
    getFireBaseUserList({ tenantId: tenantId }).then((res) => {
      resolve(res)
    })
  })
}

function DeleteUser(userIdList, tenantId) {
  return new Promise(function (resolve, _reject) {
    let getFireBaseUserList = httpsCallable(getRegionalFunctions(), 'deleteUsers')

    getFireBaseUserList({ userIdList, tenantId }).then((res) => {
      resolve(res)
    })
  })
}

function createFirebaseUser(userdetails) {
  return new Promise(function (resolve, _reject) {
    axiosCF
      .post('createFirebaseUser', userdetails)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        resolve(err.response)
      })
  })
}
function editFirebaseUser(userDetails) {
  return new Promise(function (resolve, _reject) {
    let editFirebaseUser = httpsCallable(getRegionalFunctions(), 'editFirebaseUser')
    editFirebaseUser(userDetails).then((res) => {
      resolve(res)
    })
  })
}
function getDocsFromAuthentication(uid, getPerFir) {
  return new Promise(function (resolve, _reject) {
    const getFirebaseUserByUid = httpsCallable(getRegionalFunctions(), 'getMappedTenantId')
    getFirebaseUserByUid({ uid, getPerFir }).then((res) => {
      resolve(res)
    })
  })
}

function setIsLoggedInFirstTime(uid) {
  return new Promise(function (resolve, _reject) {
    const updateAuthenticationByUid = httpsCallable(
      getRegionalFunctions(),
      'updateAuthenticationByUid'
    )
    updateAuthenticationByUid(uid).then((res) => {
      resolve(res)
    })
  })
}

const getZebraDNAServerVersion = () => {
  let sVersionFun = httpsCallable(getRegionalFunctions(), 'getZebraDNAServerVersion')
  return sVersionFun()
}

const encrypt = (data) => {
  let encryptFun = httpsCallable(getRegionalFunctions(), 'validate')
  return encryptFun(data)
}

const getEnrollmentBarcode = (profileJson) => {
  let addMessage = httpsCallable(getRegionalFunctions(), 'generateEnrollmentBarcode')
  return addMessage(profileJson)
}

const getProfileData = (tenantId, profileId, type, keys) => {
  return new Promise(function (resolve, _reject) {
    let addMessage = httpsCallable(getRegionalFunctions(), 'profileData')
    addMessage({ tenantId, profileId, type, keys })
      .then((res) => {
        //console.log('got response', res)
        resolve(res.data)
      })
      .catch((err) => {
        console.log('Error no profile found', err)
        resolve()
      })
  })
}

const enrollDevices = (deviceUdiArray, tenantId) => {
  let data = {}
  data['userId'] = tenantId
  data['deviceUdiArray'] = deviceUdiArray
  console.log('inside enrollDevices, data: ', data)
  let addMessage = httpsCallable(getRegionalFunctions(), 'updateFOTAEnrollment')
  return addMessage(data)
}

async function deleteGroupFromDB(record) {
  return new Promise(function (resolve, _reject) {
    let data = {}
    data['groupId'] = record.id
    data['groupName'] = record.groupName

    let addMessage = httpsCallable(getRegionalFunctions(), 'deleteGroup')
    addMessage(data)
      .then((res) => {
        console.log('got response', res)
        resolve(res.data.status)
      })
      .catch((err) => {
        console.log('Error deleting groups', err)
      })
  })
}

const renameGroup = async (record, updatedGroupName, existingList) => {
  return new Promise(function (resolve, _reject) {
    let data = {}
    data['groupId'] = record.id
    data['groupName'] = record.groupName
    data['updatedGroupName'] = updatedGroupName
    let groupsExisting = []
    if (existingList && existingList.length > 0) {
      existingList.map((item) => {
        groupsExisting.push(item.groupName)
      })
    }
    if (groupsExisting && groupsExisting.indexOf(updatedGroupName) !== -1) {
      resolve('Duplicate')
    } else {
      let renameGroupFirestore = httpsCallable(getRegionalFunctions(), 'renameGroup')
      renameGroupFirestore(data)
        .then((res) => {
          console.log('got response', res)
          resolve(res.data.status)
        })
        .catch((err) => {
          console.log('Error renaming groups', err)
        })
    }
  })
}

const addNewGroup = async (groupName, existingList) => {
  return new Promise(function (resolve, _reject) {
    if (typeof groupName === 'undefined' || groupName === '') {
      resolve('Empty')
    }
    let groupsExisting = []
    if (existingList && existingList.length > 0) {
      existingList.map((item) => {
        groupsExisting.push(item.groupName)
      })
    }
    if (groupsExisting && groupsExisting.indexOf(groupName) !== -1) {
      resolve('Duplicate')
    } else {
      let groupData = {}
      if (groupName) {
        groupData.groupName = groupName
        groupData.createdDateTime = moment().valueOf()
      }
      let data = {}
      data['groupData'] = groupData
      let addGroupFirestore = httpsCallable(getRegionalFunctions(), 'addGroup')
      addGroupFirestore(data)
        .then((res) => {
          console.log('got response', res)
          resolve(res.data.status)
        })
        .catch((err) => {
          console.log('Error renaming groups', err)
          resolve()
        })
    }
  })
}

function deviceAction(deviceUdi, name, type, selectedRecord, appliedLicense = []) {
  return new Promise(function (resolve) {
    let deploymentData = {
      deviceUdi: deviceUdi,
      name: name === 'SEND_MESSAGE_DEVICE' ? 'SEND_MESSAGE' : name,
      createdType: type,
      sessionStartTime: Date.now(),
      appliedLicense,
    }
    if (name === 'RESET_DEVICE_PASSCODE') {
      // deploymentData.passcodeArray = selectedRecord.passcodeArray
      deploymentData.devicePasscode = selectedRecord.devicePasscode
    }
    if (name === 'UPDATE_DEVICE_NAME') {
      deploymentData.deviceName = selectedRecord
    }
    if (name === 'SUBMIT_XML_DEVICE') {
      deploymentData.submitXmlData = selectedRecord.submitXmlData
    }
    if (name === 'SEND_MESSAGE_DEVICE') {
      deploymentData.sendMessageData = selectedRecord.sendMessageData
    }
    if (name === 'UPDATE_CLIENT_DEVICE') {
      deploymentData.checkVersionToUpdate = selectedRecord.checkVersionToUpdateSingle
    }
    let data = {}
    data['deploymentData'] = deploymentData
    let deviceData
    // Both getTwilioToken and executeDeviceAction extract the tenantId from the auth token in the backend
    if (name === ACTION_NAME.START_REMOTE_CONTROL) {
      deviceData = httpsCallable(getRegionalFunctions(), 'getTwilioToken')
    } else {
      deviceData = httpsCallable(getRegionalFunctions(), 'executeDeviceAction')
    }
    deviceData(data)
      .then((res) => {
        console.log(res, 'Inside deviceAction action response')
        resolve(res.data)
      })
      .catch((err) => {
        resolve(err)
        console.log('Error in device action', err)
      })
  })
}

const viewEnrollmentBarcode = (profileData) => {
  let addMessage = httpsCallable(getRegionalFunctions(), 'viewEnrollmentBarcode')
  return addMessage(profileData)
}

function bulkDeviceAction(
  deviceUdiArr,
  name,
  type,
  checkVersionToUpdate,
  appliedLicense = [],
  submitXmlData = '',
  sendMessageData = ''
) {
  return new Promise(function (resolve) {
    let deploymentData = {
      deviceUdiArray: deviceUdiArr,
      name: name === 'SEND_MESSAGE_DEVICE' ? 'SEND_MESSAGE' : name,
      createdType: type,
      checkVersionToUpdate,
      appliedLicense,
    }
    let data = {}
    if (submitXmlData.length) {
      deploymentData['submitXmlData'] = submitXmlData
    }
    if (sendMessageData.length) {
      deploymentData['sendMessageData'] = sendMessageData
    }
    data['deploymentData'] = deploymentData
    let deviceData = httpsCallable(getRegionalFunctions(), 'executeBulkDeviceAction')
    deviceData(data)
      .then((res) => {
        console.log(res.data)
        resolve(res.data.status)
      })
      .catch((err) => {
        resolve(err)
        console.log('Error in bulk device action', err)
      })
  })
}

const deleteEnrollmentProfile = (profileData, tenantId) => {
  return new Promise(function (resolve, _reject) {
    let data = {}
    data['userId'] = tenantId
    data['profileData'] = profileData
    let addMessage = httpsCallable(getRegionalFunctions(), 'deleteEnrollmentProfile')
    addMessage(data)
      .then((res) => {
        console.log(res)
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while deleting the profile: ' + err)
        resolve(err)
      })
  })
}

const deleteBulkEnrollmentProfiles = (profileData, tenantId) => {
  return new Promise(function (resolve, _reject) {
    let data = {}
    data['userId'] = tenantId
    data['profileData'] = profileData
    let addMessage = httpsCallable(getRegionalFunctions(), 'deleteBulkEnrollmentProfiles')
    addMessage(data)
      .then((res) => {
        console.log(res)
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while deleting bulk enrollment profiles: ' + err)
        resolve(err)
      })
  })
}

const createDeviceSetting = (settingJson) => {
  let addMessage = httpsCallable(getRegionalFunctions(), 'saveDeviceSettings')
  return addMessage(settingJson).catch((err) => {
    console.log('Error in processing Device Settings: Error ' + err)
  })
}

const createJobForDeviceSetting = (profileData, setupType, tenantId) => {
  return new Promise(function (resolve) {
    let data = { ...profileData }
    data['userId'] = tenantId
    if (setupType === APPLY_SETTING_TYPE.GUIDED_SETUP) {
      let deviceData = httpsCallable(getRegionalFunctions(), 'applyDeviceSettings')
      deviceData(data)
        .then((res) => {
          console.log('action response', res)
          resolve(res.data)
        })
        .catch((err) => {
          console.log('Error in createJobForDeviceSetting err: ', err)
          resolve(err)
        })
    } else {
      let deviceData = httpsCallable(getRegionalFunctions(), 'applyAdvancedDeviceSettings')
      deviceData(data)
        .then((res) => {
          console.log('action response', res)
          resolve(res.data)
        })
        .catch((err) => {
          console.log('Error in createJobForDeviceSetting err: ', err)
          resolve(err)
        })
    }
  })
}

const createJobForAppInstallation = (profileData, tenantId) => {
  return new Promise(function (resolve) {
    let data = { ...profileData }
    data['userId'] = tenantId
    let deviceData = httpsCallable(getRegionalFunctions(), 'saveAppInstallation')
    deviceData(data)
      .then((res) => {
        console.log('action response', res)
        resolve(res.data)
      })
      .catch((err) => {
        console.log('Error in createJobForAppInstallation err: ', err)
        resolve(err)
      })
  })
}

const createJobForAppUninstallation = (profileData, tenantId) => {
  return new Promise(function (resolve) {
    let data = { ...profileData }
    data['userId'] = tenantId
    let deviceData = httpsCallable(getRegionalFunctions(), 'uninstallApplication')
    deviceData(data)
      .then((res) => {
        console.log('action response', res)
        resolve(res.data)
      })
      .catch((err) => {
        console.log('Error in createJobForAppUninstallation err: ', err)
        resolve(err)
      })
  })
}

const manualRemoveDeviceApp = (requestData) => {
  return new Promise(function (resolve) {
    let data = { ...requestData }
    let deviceData = httpsCallable(getRegionalFunctions(), 'manualRemoveDeviceApp')
    deviceData(data)
      .then((res) => {
        console.log('manualRemoveDeviceApp response', res)
        resolve(res.data)
      })
      .catch((err) => {
        console.log('Error in manualRemoveDeviceApp err: ', err)
        resolve(err)
      })
  })
}

const deleteDeviceSettings = (profileDeploymentIds, tenantId) => {
  return new Promise(function (resolve, _reject) {
    let data = {}
    data['userId'] = tenantId
    data['profileDeploymentIds'] = profileDeploymentIds
    let addMessage = httpsCallable(getRegionalFunctions(), 'deleteDeviceSettingProfiles')
    addMessage(data)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        resolve(err)
      })
  })
}

const processLgeUpdate = (jobJson) => {
  let addMessage = httpsCallable(getRegionalFunctions(), 'updateDevice')
  return addMessage(jobJson).catch((err) => {
    console.log('Error in processing Android Updates job: Error ' + err)
  })
}

const createAppSetup = (settingJson) => {
  return new Promise((resolve) => {
    let addMessage = httpsCallable(getRegionalFunctions(), 'saveAppSetup')
    addMessage(settingJson)
      .then((res) => {
        console.log('inside createAppSetup:', res)
        resolve(res)
      })
      .catch((err) => {
        console.log('Error in createAppSetup: Error ' + err)
        resolve(err)
      })
  })
}

const createJobForAppSetup = (profileData, tenantId) => {
  return new Promise(function (resolve) {
    let data = { ...profileData }
    data['userId'] = tenantId
    console.log('Inside createJobForAppSetup, data: ' + JSON.stringify(data))
    let deviceData = httpsCallable(getRegionalFunctions(), 'applyAppSetupProfile')
    deviceData(data)
      .then((res) => {
        console.log('action response', res)
        resolve(res)
      })
      .catch((err) => {
        console.log('Error in createJobForAppSetup err: ', err)
        resolve(err)
      })
  })
}

const createAdvancedDeviceSetting = async (settingJson) => {
  return new Promise(function (resolve, _reject) {
    let addMessage = httpsCallable(getRegionalFunctions(), 'saveAdvancedDeviceSettings')
    addMessage(settingJson)
      .then((res) => {
        console.log('inside createAdvancedDeviceSetting, res: ', res)
        return resolve(res)
      })
      .catch((err) => {
        console.log('Error in processing Advanced Device Settings: ' + err)
        return resolve(err)
      })
  })
}

const flexeraLicensesRefresh = (tenantId) => {
  let data = {}
  data['userId'] = tenantId
  let addMessage = httpsCallable(getRegionalFunctions(), 'flexeraLicensesRefresh')
  return addMessage(data).catch((err) => {
    console.log('Error in getting data for sync license Error ' + err)
    return err
  })
}

const fetchLicenseSummary = (tenantId) => {
  let data = {}
  data['userId'] = tenantId
  let res = httpsCallable(getRegionalFunctions(), 'fetchLicenseSummary')
  return res(data).catch((err) => {
    console.log('Error in getting data for license Error ' + err)
    return err
  })
}

const updateDeviceLicenseStatus = (deviceUdis, tenantId) => {
  let data = {}
  data['userId'] = tenantId
  data['deviceUdiArray'] = deviceUdis
  let res = httpsCallable(getRegionalFunctions(), 'updateDeviceLicenseStatus')
  return res(data).catch((err) => {
    console.log('Error in getting data for license Error ' + err)
    return err
  })
}

async function getDeploymentDetails(tenantId) {
  let data = {}
  data['userId'] = tenantId
  return new Promise(function (resolve) {
    let res = httpsCallable(getRegionalFunctions(), 'getDeploymentList')

    return res(data)
      .then((res) => {
        // console.log('got response from saveDeviceSettings, Res: ', JSON.stringify(res.data))
        resolve(res)
      })
      .catch((err) => {
        console.log('Error in getting data for license Error ' + err)
        resolve(err)
      })
  })
}

async function getDeploymentListAfterStatusProcessDetails(tenantId) {
  let data = {}
  data['userId'] = tenantId
  return new Promise(function (resolve) {
    let res = httpsCallable(getRegionalFunctions(), 'getDeploymentListAfterStatusProcess')

    return res(data)
      .then((res) => {
        console.log(
          'got response from getDeploymentListAfterStatusProcessDetails, Res: ',
          JSON.stringify(res.data)
        )
        resolve(res)
      })
      .catch((err) => {
        console.log('Error in getting data ' + err)
        resolve(err)
      })
  })
}

const getProcessedDeviceStatusInDeployment = (data, tenantId) => {
  data['userId'] = tenantId
  let res = httpsCallable(getRegionalFunctions(), 'getProcessedDeviceStatusInDeployment')
  return res(data).catch((err) => {
    console.log('Error in getting data. Error ' + err)
    return err
  })
}

const getDeviceDetailsInSetting = (data, tenantId) => {
  data['userId'] = tenantId
  let res = httpsCallable(getRegionalFunctions(), 'getDeviceStatusInDeployment')
  return res(data).catch((err) => {
    console.log('Error in getting data for license Error ' + err)
    return err
  })
}

const licenseWrapper = (tenantId, source, data = {}) => {
  data['source'] = source
  data['userId'] = tenantId
  return new Promise(function (resolve, _reject) {
    axiosCF
      .post('licenseWrapper', data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        resolve({ status: 'error', message: 'Error, kindly try again' })
      })
  })
}

// EDCL-31 -->
const claimLicense = ( data = {}) => {
  return new Promise(function (resolve, _reject) {
    axiosCF
      .post('claimLicenses', data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        resolve({ status: 'error', message: 'Error, kindly try again' })
      })
  })
}

const updateProductSettings = (data = {}) => {
  return new Promise(function (resolve, _reject) {
    axiosCF
      .post('updateProductSettings', data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        resolve({ status: 'error', message: 'Error, kindly try again' })
      })
  })
}

// <-- EDCL-31

const deleteAssignedDevice = (devices, tenantId, emailId) => {
  return new Promise(function (resolve, _reject) {
    let data = { userId: tenantId, devices, emailId }
    let addMessage = httpsCallable(getRegionalFunctions(), 'deleteDeploymentAssignedDevice')
    addMessage(data)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while deleting deployment assigned device: ' + err)
        resolve(err)
      })
  })
}

const reapplyAssignedDevice = (
  devices,
  tenantId,
  emailId,
  totalIssueStatusCount,
  isPartOfMasterProfile
) => {
  return new Promise(function (resolve, _reject) {
    let data = { devices, userId: tenantId, emailId, totalIssueStatusCount, isPartOfMasterProfile }
    let addMessage = httpsCallable(getRegionalFunctions(), 'reapplyDeploymentAssignedDevice')
    addMessage(data)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while reapply deployment assigned device: ' + err)
        resolve(err)
      })
  })
}

const reapplyRemoveAssociateDevice = (
  devices,
  tenantId,
  emailId,
  associatedProfiles,
  masterProfileId,
  action,
  appRetentionAction = null // no default value because of feature flag check
) => {
  return new Promise(function (resolve, _reject) {
    let data = { devices, userId: tenantId, emailId, associatedProfiles, masterProfileId, action }

    if(appRetentionAction) data.appRetentionAction = appRetentionAction
    let addMessage = httpsCallable(getRegionalFunctions(), 'reapplyRemoveDeploymentAssociateDevice')
    addMessage(data)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while reapply deployment assigned device: ' + err)
        resolve(err)
      })
  })
}

/**
 *
 * @param {*} deploymentId
 * @param {*} deviceId
 * @returns Deleting device from app setup
 */
const deleteAssignedDeviceFromApp = (
  deploymentId,
  devices,
  appInfo,
  profileId,
  userId,
  category,
  emailId,
  masterProfileDeploymentId,
  appRetentionAction = null
) => {
  return new Promise(function (resolve, _reject) {
    let data = {
      userId,
      deploymentId,
      devices,
      ...appInfo,
      profileId,
      category,
      emailId,
      masterProfileDeploymentId,
    }
    if(appRetentionAction) data.appRetentionAction = appRetentionAction

    let addMessage = httpsCallable(getRegionalFunctions(), 'deleteDeploymentAssignedDeviceFromApp')
    addMessage(data)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while deleting deployment assigned device: ' + err)
        resolve(err)
      })
  })
}

const reapplyAssignedDeviceFromApp = (payload) => {
  return new Promise(function (resolve, _reject) {
    let addMessage = httpsCallable(getRegionalFunctions(), 'reapplyDeploymentAssignedDeviceFromApp')
    addMessage(payload)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while reapply deployment assigned device: ' + err)
        resolve(err)
      })
  })
}

const allocateLicenses = async (
  formData,
  selectedDevices,
  deviceList,
  totalLicenseCount,
  tenantId,
  featureName
) => {
  return new Promise(function (resolve, _reject) {
    let data = {}
    data['userId'] = tenantId
    data['formData'] = formData
    data['selectedDevices'] = selectedDevices
    data['devices'] = deviceList
    data['featureName'] = featureName

    axiosCF
      .post('allocateLicenses', data)
      .then((res) => {
        console.log('Inside allocateLicenses, .then' + JSON.stringify(res))
        resolve(res)
      })
      .catch((err) => {
        console.log('Inside allocateLicenses, .catch' + JSON.stringify(err.message))
        resolve(err)
      })
  })
}

const saveDeviceSettingWallpapers = (data) => {
  return new Promise(function (resolve, _reject) {
    let addMessage = httpsCallable(getRegionalFunctions(), 'uploadDeviceSettingWallpapers')
    addMessage(data)
      .then((res) => {
        console.log(
          'Inside saveDeviceSettingWallpapers: response from server: ' + JSON.stringify(res)
        )
        resolve(res)
      })
      .catch((err) => {
        console.log(
          'Inside saveDeviceSettingWallpapers: Error while allocating: ' + JSON.stringify(err)
        )
        resolve(err)
      })
  })
}

const getAccessToken = (tenantId) => {
  let data = {}
  data['userId'] = tenantId
  let addMessage = httpsCallable(getRegionalFunctions(), 'getLgeAccessToken')
  return addMessage(data).catch((err) => {
    console.log('Error while getting access token, Error ' + err)
    return err
  })
}

async function getDeploymentDetailsList(profileType, tenantId) {
  let data = {}
  data['userId'] = tenantId
  data.profileType = profileType
  return new Promise(function (resolve) {
    let res = httpsCallable(getRegionalFunctions(), 'getDeploymentDetailsList')

    return res(data)
      .then((res) => {
        console.log('got response from getDeploymentDetailsList, Res: ', JSON.stringify(res.data))
        if (res.data && res.data.status === 'SUCCESS' && res.data.result) {
          resolve(res.data.result)
        } else {
          resolve([])
        }
      })
      .catch((err) => {
        console.log('Error in getting data form getDeploymentDetailsList Error ' + err)
        resolve([])
      })
  })
}

async function getDeploymentDetailsListWithUpdatedStatuses(profileType, tenantId) {
  let data = {}
  data['userId'] = tenantId
  data.profileType = profileType
  return new Promise(function (resolve) {
    let res = httpsCallable(getRegionalFunctions(), 'getDeploymentDetailsListWithUpdatedStatuses')

    return res(data)
      .then((res) => {
        res.data.status && res.data.status === 'SUCCESS' && res.data.result
          ? resolve(res.data.result)
          : resolve([])
      })
      .catch((err) => {
        console.log('Error in getting data ' + err)
        resolve([])
      })
  })
}
const collectDeveloperData = async (developerData, tenantId) => {
  let data = {}
  data['userId'] = tenantId
  data['devData'] = developerData
  let addMessage = httpsCallable(getRegionalFunctions(), 'collectDeveloperData')
  return addMessage(data).catch((err) => {
    console.log('Error while getting access token, Error ' + err)
    return err
  })
}

const getSignedUrlForUpload = async (fileName, tenantId) => {
  let data = {}
  data['userId'] = tenantId
  data['fileName'] = fileName

  let addMessage = httpsCallable(getRegionalFunctions(), 'getV4UploadSignedUrl')
  return addMessage(data).catch((err) => {
    console.log('Error while getting the signed URL for upload, Error ' + JSON.stringify(err))
    return { status: 'Error' }
  })
}

const createOrUpdateAppProfile = async (
  request,
  profileId,
  isEdit = false,
  tenantId,
  isAddVersion = false
) => {
  let data = {}
  data['userId'] = tenantId
  data['payload'] = request
  if (profileId && profileId != '') {
    data['profileId'] = profileId
  }
  data['isEdit'] = isEdit
  data['isAddVersion'] = isAddVersion

  let addMessage = httpsCallable(getRegionalFunctions(), 'createOrUpdateAppProfile')
  return addMessage(data).catch((err) => {
    console.log('Error while creating/updating the app profile, Error ' + JSON.stringify(err))
    return { status: 'Error' }
  })
}

const deleteFileFromStorage = async (filePath, tenantId) => {
  let data = {}
  data['userId'] = tenantId
  data['filePath'] = filePath

  let addMessage = httpsCallable(getRegionalFunctions(), 'deleteFile')
  return addMessage(data).catch((err) => {
    console.log('Error while deleting the file from storage, Error ' + JSON.stringify(err))
    return { status: 'Error' }
  })
}

const closeRCRoom = async (deploymentId, roomSID, udi) => {
  let data = {}
  data['deploymentId'] = deploymentId
  data['roomSID'] = roomSID
  data['udi'] = udi
  data['sessionEndTime'] = Date.now()
  // terminateRoom extracts the tenantId from the auth token in the backend
  let addMessage = httpsCallable(getRegionalFunctions(), 'terminateRoom')
  return addMessage(data)
    .then((res) => {
      console.log('Room termination res' + JSON.stringify(res))
      return res
    })
    .catch((err) => {
      console.log('Error while terminating room, Error ' + JSON.stringify(err))
      return { success: false }
    })
}

const uploadFileToStorage = async (data) => {
  let addMessage = httpsCallable(getRegionalFunctions(), 'getZebraAppsUploadSignedUrl')
  return addMessage(data).catch((err) => {
    console.log('Error while getting the signed URL for upload, Error ' + JSON.stringify(err))
    return { status: 'Error' }
  })
}

const createDeploymentForBulkDeviceAutoNaming = (payload) => {
  return new Promise(function (resolve) {
    let cloudCall = httpsCallable(getRegionalFunctions(), 'createDeploymentForBulkDeviceAutoNaming')
    cloudCall(payload)
      .then((res) => {
        console.log('got response from getDeploymentDetailsList, Res: ', JSON.stringify(res.data))
        if (res.data && res.data.status === 'success') {
          resolve({ success: true })
        } else {
          if (res.data && res.data.result && res.data.result === LICENSES.LICENSE_ERROR) {
            resolve({ success: false, result: res.data.result })
          } else {
            resolve({ success: false })
          }
        }
      })
      .catch((err) => {
        console.log('Error in getting data form getDeploymentDetailsList Error ' + err)
        resolve({ success: false })
      })
  })
}

const getZebraInfoTokens = (tenantId) => {
  return new Promise(function (resolve, reject) {
    var data = {}
    data['userId'] = tenantId

    console.log(' data : ==> ', data)
    axiosCF
      .post('getZebraInfoTokens', data)
      .then((res) => {
        console.log(res)
        resolve(res)
      })
      .catch((err) => {
        console.log('Error in getZebraInfoTokens: ', err.response)
        let errData = err.response
          ? err.response
          : { status: 'error', error: 'Error in getZebraInfoTokens' }
        resolve(errData)
      })
  })
}
const saveZebraServicesData = (payload) => {
  return new Promise(function (resolve, reject) {
    console.log(' data : ==> ', payload)
    axiosCF
      .post('connectToZebraServices', payload)
      .then((res) => {
        console.log(res)
        resolve(res)
      })
      .catch((err) => {
        console.log('Error in saveZebraServicesData: ', err.response)
        let errData = err.response
          ? err.response
          : { status: 'error', error: 'Error in saveZebraServicesData' }
        resolve(errData)
      })
  })
}

const expireElsEnrollments = (expireEnrollmentArr, tenantId) => {
  return new Promise(function (resolve, reject) {
    let data = {}
    data['userId'] = tenantId
    data['expireEnrollmentArr'] = expireEnrollmentArr
    return axiosCF
      .post('expireElsEnrollments', data)
      .then((res) => {
        console.log('done expiring')
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while expiring: ', err.message)
        resolve({ status: 'error', result: ERROR_MESSAGE.ENROLLMENT_EXPIRE_ERROR })
      })
  })
}

const deleteElsEnrollments = (deleteEnrollmentArr, tenantId) => {
  return new Promise(function (resolve, reject) {
    let data = {}
    data['userId'] = tenantId
    data['deleteEnrollmentArr'] = deleteEnrollmentArr
    return axiosCF
      .post('deleteElsEnrollments', data)
      .then((res) => {
        console.log('done deleting')
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while deleting: ', err.message)
        resolve({ status: 'error', result: ERROR_MESSAGE.ENROLLMENT_DELETE_ERROR })
      })
  })
}

const updateDeviceUserStatus = (tenantId, enrollmentArr) => {
  return new Promise(function (resolve, reject) {
    console.log('inside updateDeviceUserCurrentPage')
    let data = {}
    data['userId'] = tenantId;
    data['enrollmentArr'] = enrollmentArr;
    return axiosCF
      .post('updateDeviceUserStatus', data)
      .then((res) => {
        console.log('done updating')
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while updating: ', err.message)
        resolve({ status: 'error', result: ERROR_MESSAGE.DEVICE_USER_UPDATE_ERROR })
      })
  })
}

const updateDeviceUsers = (tenantId) => {
  return new Promise(function (resolve, reject) {
    console.log('inside updateDeviceUsers')
    let data = {}
    data['userId'] = tenantId
    return axiosCF
      .post('updateDeviceUsers', data)
      .then((res) => {
        console.log('done updating')
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while updating: ', err.message)
        resolve({ status: 'error', result: ERROR_MESSAGE.DEVICE_USER_UPDATE_ERROR })
      })
  })
}

// EDCL-293 -->
const reEnrollmentRequest = (reEnrollEnrollmentArr) => {
  return axiosMDNAv2
    .post('enrollments/re-request', { enrollmentIds: reEnrollEnrollmentArr })
    .then((res) => {
      console.log('done re-enrolling')
      return res
    })
    .catch((err) => {
      console.log('Error while re-enrolling: ', err.message)
      return { status: 'error', result: ERROR_MESSAGE.ENROLLMENT_REENROLL_ERROR }
    })
}

const validateUserEnrollmentRequest = (token) => {
  // return Promise.resolve({ status: 200, result: 'VALIDATION_SUCCESS' })
  return axiosEnrollment
    .post('enrollments/token/validate', {}, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      console.log('validated enrollment request', res)
      return res
    })
    .catch((err) => {
      console.log('Error while validating enrollment request: ', err.message)
      return err.response && err.response.status === 401
        ? { status: 401, result: 'UNAUTHORIZED' }
        : { status: 'error', result: err.message || ERROR_MESSAGE.ENROLLMENT_VALIDATION_ERROR }
    })
}

const markEnrollmentComplete = (reqData) => {
  return axiosEnrollment
    .post('enrollments/complete', reqData.body, {
      headers: {
        authorization: `Bearer ${reqData.token}`,
      },
    })
    .then((res) => {
      console.log('marked enrollment complete', res)
      return res
    })
    .catch((err) => {
      console.log('Error while marking enrollment complete: ', err.message)
      return err.response
        ? { status: err.response.status, result: err.response.data }
        : { status: 'NETWORK_ERROR', result: err.message || ERROR_MESSAGE.ENROLLMENT_COMPLETE_ERROR }
    })
}

const getIGProfiles = () => {
  return axiosMDNA
    .get('app-setup-profile?appName=IG')
    .then((res) => {
      console.log('IG profiles', res)
      return res
    })
    .catch((err) => {
      console.log('Error while fetching IG profiles: ', err.message)
      return err.response
        ? { status: err.response.status, result: err.response.data }
        : { status: 'NETWORK_ERROR', result: err.message || ERROR_MESSAGE.IG_PROFILE_FETCH_ERROR }
    })
}

const validateIGProfile = (profileId) => {
  return axiosMDNAv2
    .post('validateIGProfileId', { igProfileId: profileId })
    .then((res) => {
      console.log('validated IG profile', res)
      return res
    })
    .catch((err) => {
      console.log('Error while validating IG profile: ', err.message)
      return err.response
        ? { status: err.response.status, error: err.response.data }
        : { status: 'NETWORK_ERROR', error: err.message || ERROR_MESSAGE.IG_NETWORK_FETCH_ERROR }
    })
}


// <-- EDCL-293
const initiateBackgroundJob = (data, tenantId) => {
  console.log('initiateBackgroundJob, jobType ', data.jobType)
  return new Promise((resolve) => {
    data['userId'] = tenantId
    return axiosCF
      .post('initiateBackgroundJob', data)
      .then((res) => {
        console.log('job response', res)
        resolve(res.data)
      })
      .catch((err) => {
        console.log('Error in initiateBackgroundJob err: ', err)
        resolve({ status: 'error' })
      })
  })
}

const initiateBackgroundJobProfileDependency = (data, tenantId) => {
  console.log('initiateBackgroundJobProfileDependency, jobType ', data.jobType)
  return new Promise((resolve) => {
    data['userId'] = tenantId
    return axiosCF
      .post('initiateBackgroundJobProfileDependency', data)
      .then((res) => {
        console.log('job response', res)
        resolve(res.data)
      })
      .catch((err) => {
        console.log('Error in initiateBackgroundJobProfileDependency err: ', err)
        resolve({ status: 'error' })
      })
  })
}

const initiateExportBackgroundJob = (data, tenantId) => {
  console.log('initiateExportBackgroundJob, jobType ', data.jobType)
  return new Promise((resolve) => {
    data['userId'] = tenantId
    return axiosCF
      .post('initiateExportBackgroundJob', data)
      .then((res) => {
        console.log('job response', res)
        resolve(res.data)
      })
      .catch((err) => {
        console.log('Error in initiateExportBackgroundJob err: ', err)
        resolve({ status: 'error' })
      })
  })
}

const initiateBackgroundJobAppSetup = (data, tenantId) => {
  console.log('initiateBackgroundJobAppSetup, jobType ', data.jobType)
  return new Promise((resolve) => {
    data['userId'] = tenantId
    return axiosCF
      .post('initiateBackgroundJobAppSetup', data)
      .then((res) => {
        console.log('job response', res)
        resolve(res.data)
      })
      .catch((err) => {
        console.log('Error in initiateBackgroundJobAppSetup err: ', err)
        resolve({ status: 'error' })
      })
  })
}
const getPermissions = (tenantId, uuid) => {
  return new Promise(function (resolve, reject) {
    console.log('inside getPermissions')
    let data = { userId: tenantId, uuid: uuid }
    return axiosCF
      .post('retriveUser', data)
      .then((res) => {
        console.log('Successfully fetched')
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while fetching user permission: ', err.message)
        resolve({ status: 'error' })
      })
  })
}

const deleteRole = (roleData, tenantId) => {
  return new Promise(function (resolve, reject) {
    console.log('deleteRole ')
    let data = {}
    data['userId'] = tenantId
    data['data'] = roleData
    return axiosCF
      .post('deleteRole', data)
      .then((res) => {
        console.log('done deleting the role ', JSON.stringify(res.data))
        resolve(res.data)
      })
      .catch((err) => {
        console.log('Error while deleting: ', err.message)
        resolve({ status: 'error', result: USER_ROLE_MANGEMENT_MSG.ROLE_DELETE_ERROR })
      })
  })
}

const profileExport = (tenantId, profileId, profileName, category) => {
  return new Promise((resolve, reject) => {
    console.log('Info: Starting profile export.')
    const requestData = {
      userID: tenantId,
      profileID: profileId,
      profileName: profileName,
      category: category,
    }
    console.log('Request data:', requestData)
    axiosCF
      .post('/exportProfileData', requestData, {
        headers: {
          'Content-Type': CONTENT_TYPE.JSON,
        },
        responseType: CONTENT_TYPE.JSON,
      })
      .then((response) => {
        const responseData =
          typeof response.data === 'string' ? JSON.parse(response.data) : response.data
        if (responseData.data) {
          const dataObject = responseData.data
          const dataString = JSON.stringify(dataObject)
          const blob = new Blob([dataString], { type: 'text/plain' })
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = `${profileName}.dprof`
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
          resolve(response)
        }
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response)
        } else {
          reject({ status: STATUS.ERROR, error: error.message })
        }
      })
  })
}

const profileXMLExport = (tenantId, profileId, profileName, category) => {
  return new Promise((resolve, reject) => {
    console.log('Info, inside profileXMLExport')

    const data = {
      userID: tenantId,
      profileID: profileId,
      profileName: profileName,
      category: category,
    }
    console.log('Data: ==> ', data)
    axiosCF
      .post('/exportProfileXML', data, {
        headers: {
          'Content-Type': CONTENT_TYPE.JSON,
        },
        responseType: CONTENT_TYPE.JSON,
      })
      .then((response) => {
        const responseData = JSON.parse(response.data)
        if (responseData.status === STATUS.SUCCESS) {
          const blob = new Blob([responseData.data], { type: 'application/xml' })
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = `${profileName}.xml`
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
          resolve(response)
        }
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response)
        } else {
          reject({ status: STATUS.ERROR, error: error.message })
        }
      })
  })
}

const profilePDFExport = (tenantId, profileId, profileName, category) => {
  return new Promise((resolve, reject) => {
    console.log('Info, inside profilePDFExport')

    const data = {
      userID: tenantId,
      profileID: profileId,
      profileName: profileName,
      category: category,
    }
    console.log('Data: ==> ', data)
    axiosCF
      .post('/exportProfileBarcode', data, {
        responseType: 'json',
      })
      .then((response) => {
        console.log('Response:', response)
        const pdfData = response.data.data
        const byteArray = new Uint8Array(pdfData.data)
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const a = document.createElement('a')
        a.href = window.URL.createObjectURL(blob)
        a.download = `${profileName}.pdf`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(a.href)
        resolve(response)
      })
      .catch((error) => {
        if (error.response && error.response.data && error.response.data.data) {
          console.log('Error:', error.response.data.data.message)
          console.log('InputData:', error.response.data.data.inputData)
        }
        if (error.response) {
          reject(error.response)
        } else {
          reject({ status: STATUS.ERROR, error: error.message })
        }
      })
  })
}

const importProfileDataFile = (file, tenantId) => {
  return new Promise((resolve, reject) => {
    console.log('info,inside importProfileDataFile')
    const userId = tenantId
    const formData = new FormData()
    formData.append('file', file)
    formData.append('UserId', userId)
    axiosCF
      .post('/importProfileData', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        transformRequest: (data, headers) => {
          return formData
        },
        responseType: CONTENT_TYPE.JSON,
      })
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        const error = err.response
          ? err.response.data
          : { status: 'error', error: 'Error in fileUploadToServer' }
        reject(error)
      })
  })
}

//Wireless Insights Code Start
const connectWirelessInsightsService = (body) => {
  return new Promise(function (resolve, reject) {
    return axiosCF
      .post(`/createTenantWrapper`, body)
      .then((res) => {
        console.log('connection successfull')
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while updating: ', err.message)
        resolve({ status: 'error', result: ERROR_MESSAGE.DEVICE_USER_UPDATE_ERROR })
      })
  })
}

const getEnrollmentConfig = (body) => {
  return new Promise(function (resolve, reject) {
    return axiosCF
      .post(`/getEnrollmentConfigWrapper`, body)
      .then((res) => {
        console.log('connection successfull')
        resolve(res)
      })
      .catch((err) => {
        console.log('Error while updating: ', err.message)
        resolve({ status: 'error', result: ERROR_MESSAGE.DEVICE_USER_UPDATE_ERROR })
      })
  })
}

const getFeatureFlags = (tenantId) => {
  console.log('inside getFeatureFlags' + tenantId)

  const promiseArr = [
    axiosCF.get('getSystemFeatureFlags', {
      headers: {
        userid: tenantId,
      },
    }),
    axiosCF.get('getTenantFeatureFlags', {
      headers: {
        userid: tenantId,
      },
    }),
  ]

  return Promise.allSettled(promiseArr).then((results) => {
    const flags = {
      system: {},
      tenant: {},
    }

    results.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        const data = result.value.data.data
        if (index === 0) {
          console.log('Successfully fetched system feature flags')
          flags.system = data || {}
        } else {
          console.log('Successfully fetched tenant feature flags')
          flags.tenant = data || {}
        }
      } else {
        console.error(
          `Error while fetching ${index === 0 ? 'system' : 'tenant'} feature flags:`,
          result.reason.message,
          result.reason.response ? result.reason.response.data : ''
        )
      }
    })

    return flags
  })
}

// Ends

// CMS

const addContent = async (name, description, mediaType, media) => {
  const body = {
    name,
    description,
    mediaType,
    media,
  }

  try {
    const header = await createHeader()
    const response = await axiosZS.post(`/cms/content`, body, header)
    if (response.status === 200) {
      return {
        success: true,
        contentId: response.data.contentId,
      }
    }
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const createPlaylist = async (name, description, mediaType, contentIds, duration = 0) => {
  const body = {
    name,
    description,
    mediaType,
    contentIds,
    duration,
  }

  try {
    const header = await createHeader()
    const response = await axiosZS.post(`/cms/playlist`, body, header)
    if (response.status === 200) {
      return {
        success: true,
        contentId: response.data.contentId,
      }
    }
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const editPlaylist = async (playlistId, updatePlaylist) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.put(`/cms/playlist/${playlistId}`, updatePlaylist, header)
    if (response.status === 200) {
      return {
        success: true,
      }
    }
  } catch (error) {
    console.log(' Error', error)
    if (error.response) {
      if (error.response.status === 409 && error.response.data?.schedules) {
        return {
          success: false,
          usedSchedules: error.response.data.schedules,
        }
      } else {
        return {
          success: false,
          message: error.response.data.message || 'An error occurred.',
        }
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const getContents = async () => {
  try {
    const header = await createHeader()
    const response = await axiosZS.get(`/cms/content`, header)
    if (response.status === 200) {
      return {
        success: true,
        contents: response.data.contents,
      }
    }
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const getContentDetails = async (contentId) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.get(`/cms/content/${contentId}`, header)
    console.log('getContentDetails', response)
    if (response.status === 200) {
      return {
        success: true,
        contents: response.data.data.contents,
      }
    }
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}
const updateContent = (tenantId, contentId, content) => {
  return new Promise((resolve, reject) => {
    const updateContent = httpsCallable(getFunctions(), 'updateContent')
    updateContent({ tenantId, contentId, content })
      .then((response) => {
        if (response.data && response.data.status === 'success') {
          resolve({ success: true, message: response.data.message })
        } else {
          if (
            response.data &&
            response.data.result &&
            response.data.result === LICENSES.LICENSE_ERROR
          ) {
            resolve({ success: false, contents: response.data.result })
          } else {
            resolve({ success: false })
          }
        }
      })
      .catch((error) => {
        console.log('Error in updateContent Error ', JSON.stringify(error))
        reject(error)
      })
  })
}

/* This Api to delete content temporary */
const moveContentToRecycle = async (contentIds) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.post(`/cms/content/recycle`, { contentIds }, header)
    if (response.status === 200) {
      return {
        success: true,
      }
    }
  } catch (error) {
    if (error.response) {
      if (error.response.status === 409 && error.response.data?.conflicts) {
        console.log('Use Content::', error.response.data)
        return {
          success: false,
          conflictContents: error.response.data.conflicts || null,
        }
      } else {
        return {
          success: false,
          message: error.response.data.message || 'An error occurred.',
        }
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}
/* This Api is for restore content which is recovery from delete content temporary */
const restoreContent = async (contentIds) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.post(`/cms/content/restore`, { contentIds }, header)
    if (response.status === 200) {
      return {
        success: true,
      }
    }
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}
/* Parmanent Delete */
const deleteContent = async (contentIds) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.post(`/cms/content/delete`, { contentIds }, header)
    if (response.status === 200) {
      return {
        success: true,
      }
    }
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const createSchedule = async (newSchedule) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.post(`/cms/schedule`, newSchedule, header)
    if (response.status === 200) {
      return {
        success: true,
        scheduleId: response.data.id,
      }
    }
  } catch (error) {
    //overlapedSchedules - todo
    console.log(' Error', error)
    if (error.response) {
      if (error.response.status === 409) {
        return {
          success: false,
          overlapedSchedules: error.response.data.overlapedSchedules,
        }
      } else {
        return {
          success: false,
          message: error.response.data.message || 'An error occurred.',
        }
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const updateSchedule = async (scheduleId, schedule) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.put(`/cms/schedule/${scheduleId}`, schedule, header)
    if (response.status === 200) {
      return {
        success: true,
        scheduleId: response.data.message,
      }
    }
  } catch (error) {
    //overlapedSchedules - todo
    console.log(' Error', error)
    if (error.response) {
      if (error.response.status === 409) {
        return {
          success: false,
          overlapedSchedules: error.response.data.overlapedSchedules,
        }
      } else {
        return {
          success: false,
          message: error.response.data.message || 'An error occurred.',
        }
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const getSchedules = async () => {
  try {
    const header = await createHeader()
    const response = await axiosZS.get(`/cms/schedule`, header)
    if (response.status === 200) {
      return {
        success: true,
        schedules: response.data.schedules,
      }
    }
  } catch (error) {
    console.log(' Error', error)
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const getSchedule = async (scheduleId) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.get(`/cms/schedule/${scheduleId}`, header)
    if (response.status === 200) {
      return {
        success: true,
        schedule: response.data.schedule,
      }
    }
  } catch (error) {
    console.log(' Error', error)
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const deleteSchedule = async (scheduleIds) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.post(`/cms/schedule/delete`, { scheduleIds }, header)
    if (response.status === 200) {
      return {
        success: true,
        message: response.data.message,
      }
    }
  } catch (error) {
    console.log(' Error', error)
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const getSchedulesByDeviceId = async (deviceId) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.get(`/cms/devices/schedule/${deviceId}`, header)
    if (response.status === 200) {
      return {
        success: true,
        schedules: response.data.schedules,
      }
    }
  } catch (error) {
    console.log(' Error', error)
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const myDevices = async () => {
  try {
    const response = await axiosCF.get(`/cms/devices`)
    if (response.status === 200) {
      return {
        success: true,
        devices: response.data.devices,
      }
    }
  } catch (error) {
    console.log(' Error', error)
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const getCMServiceConfiguration = async (tenantId) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.get(`/cms/service/${tenantId}`, header)
    // const response = await axiosCF.get(`/cms/service/${tenantId}`)
    if (response.status === 200) {
      return {
        success: true,
        config: response.data?.config,
      }
    }
  } catch (error) {
    console.log(' Error', error)
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const getCMSLogs = async (
  search,
  searchField,
  contentId,
  scheduleId,
  deviceId,
  page = 1,
  limit = 100
) => {
  let params = { page, limit }

  // Search by a specific field
  if (search && searchField) {
    params.search = search
    params.searchField = searchField
  }

  // Filter by contentId
  if (contentId) {
    params.contentId = contentId
  }

  // Filter by scheduleId
  if (scheduleId) {
    params.scheduleId = scheduleId
  }

  // Filter by deviceId
  if (deviceId) {
    params.deviceId = deviceId
  }

  try {
    const header = await createHeader()
    const response = await axiosZS.get(`/cms/logs`, { params, ...header })
    if (response.data?.status === 'success') {
      console.log('getCMSLogs', response)
      return {
        success: true,
        logs: response.data?.logs,
      }
    }
  } catch (error) {
    console.log(' Error', error)
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const getCMUsedSpace = async (tenantId) => {
  try {
    const header = await createHeader()
    const response = await axiosZS.get(`/cms/storage-info/`, header)
    if (response.status === 200) {
      return {
        success: true,
        usedSpace: response.data?.usedSpace,
      }
    }
  } catch (error) {
    console.log(' Error', error)
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const createmasterProfiles = (data) => {
  return new Promise(function (resolve, reject) {
    let resultData = {}
    resultData['data'] = data
    return axiosCF
      .post('createmasterProfiles', resultData)
      .then((res) => {
        console.log('Inside createmasterProfiles: response from server: ' + JSON.stringify(res))
        resolve(res)
      })
      .catch((err) => {
        console.log('Inside createmasterProfiles: Error while allocating: ' + JSON.stringify(err))
        resolve(err)
      })
  })
}

const fetchLoginHistory = async (tenantId, enrollmentId, params = {}) => {
  try {
    const response = await axiosCF.get(
      `${LOGIN_HISTORY_ROUTE}/${enrollmentId}/loginHistory`,
      { 
        params,
        headers: {
          userid: tenantId
        }
      }
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data?.data,
      }
    }
  } catch (error) {
    console.log('Error fetching login history:', error)
    if (error.response) {
      return {
        success: false,
        message: error.response.data.message || 'An error occurred.',
      }
    } else {
      return {
        success: false,
        message: 'Network error or server did not respond.',
      }
    }
  }
}

const exportLoginHistory = async (tenantId, enrollmentId, params = {}) => {
  if (!tenantId || !enrollmentId) {
    const errorMessage = 'Missing required parameters: tenantId or enrollmentId.';
    console.error('Error exporting login history:', errorMessage);
    return {
      success: false,
      message: errorMessage,
    };
  }
  try {
    const response = await axiosCF.post(
      `${EXPORT_LOGIN_HISTORY_ROUTE}/${enrollmentId}/loginHistory/export`,
      {},
      {
        params: params,
        headers: {
          userid: tenantId
        }
      }
    )
    // Axios' default behavior is to throw for non-2xx status codes, which are caught below.
    // This ensures we handle all successful (2xx) responses consistently.
    return {
      success: true,
      data: response.data?.data,
    };
  } catch (error) {
    console.log('Error exporting login history:', error.message);
    if (error.response) {
      // The request was made and the server responded with a status code outside the 2xx range.
      return {
        success: false,
        message: error.response.data?.message || `Request failed with status ${error.response.status}.`,
      };
    } else {
      // For network errors or other issues where no response was received.
      return {
        success: false,
        message: 'Network error or server did not respond.',
      };
    }
  }
}

export {
  getUserList,
  DeleteUser,
  profileExport,
  profileXMLExport,
  createFirebaseUser,
  getDocsFromAuthentication,
  setIsLoggedInFirstTime,
  getZebraDNAServerVersion,
  encrypt,
  getEnrollmentBarcode,
  addNewGroup,
  renameGroup,
  deleteGroupFromDB,
  viewEnrollmentBarcode,
  bulkDeviceAction,
  deviceAction,
  deleteEnrollmentProfile,
  deleteBulkEnrollmentProfiles,
  editFirebaseUser,
  createDeviceSetting,
  createJobForDeviceSetting,
  createJobForAppInstallation,
  createJobForAppUninstallation,
  manualRemoveDeviceApp,
  deleteDeviceSettings,
  processLgeUpdate,
  createAppSetup,
  createJobForAppSetup,
  createAdvancedDeviceSetting,
  flexeraLicensesRefresh,
  fetchLicenseSummary,
  updateDeviceLicenseStatus,
  getDeploymentDetails,
  getDeviceDetailsInSetting,
  deleteAssignedDevice,
  reapplyAssignedDevice,
  reapplyRemoveAssociateDevice,
  allocateLicenses,
  saveDeviceSettingWallpapers,
  getAccessToken,
  enrollDevices,
  getDeploymentListAfterStatusProcessDetails,
  getProcessedDeviceStatusInDeployment,
  getDeploymentDetailsList,
  getDeploymentDetailsListWithUpdatedStatuses,
  collectDeveloperData,
  getSignedUrlForUpload,
  createOrUpdateAppProfile,
  deleteFileFromStorage,
  closeRCRoom,
  deleteAssignedDeviceFromApp,
  reapplyAssignedDeviceFromApp,
  uploadFileToStorage,
  createDeploymentForBulkDeviceAutoNaming,
  getProfileData,
  getZebraInfoTokens,
  expireElsEnrollments,
  deleteElsEnrollments,
  saveZebraServicesData,
  updateDeviceUsers,
  reEnrollmentRequest, // EDCL-293
  validateUserEnrollmentRequest, // EDCL-293
  markEnrollmentComplete, // EDCL-293
  getIGProfiles, // EDCL-293
  validateIGProfile, // EDCL-293
  licenseWrapper,
  claimLicense, // EDCL-31
  updateProductSettings, // EDCL-31
  initiateBackgroundJob,
  initiateBackgroundJobAppSetup,
  getPermissions,
  deleteRole,
  importProfileDataFile,
  profilePDFExport,
  connectWirelessInsightsService,
  getFeatureFlags,
  getEnrollmentConfig,
  initiateExportBackgroundJob,
  initiateBackgroundJobProfileDependency,
  addContent,
  createPlaylist,
  editPlaylist,
  getContents,
  getContentDetails,
  updateContent,
  moveContentToRecycle,
  restoreContent,
  deleteContent,
  createSchedule,
  updateSchedule,
  getSchedules,
  getSchedule,
  deleteSchedule,
  getSchedulesByDeviceId,
  myDevices,
  getCMServiceConfiguration,
  getCMSLogs,
  getCMUsedSpace,
  createmasterProfiles,
  updateDeviceUserStatus,
  fetchLoginHistory,
  exportLoginHistory,
}
